var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"glyphicon glyphicon-calendar fa fa-calendar mr-2"}),(_vm.date)?_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(_vm.date)))]):_c('span',[_vm._v(_vm._s(_vm.$t(_vm.placeholder)))])])}
var staticRenderFns = []

export { render, staticRenderFns }